module.exports = __webpack_public_path__ + "static/media/container.726dc80a.svg";